import { FC } from 'react';
import { ErrorFields } from '../admin/AdminRegistrationSteps';
import { StyledAccordianSummary, StyledAccordion, StyledAccordionDetails } from './SpeakerForm';
import BasePersonSection from '../shared/BaseCustomRegistrationSection';
import SocialLinksFields from '../shared/SocialLinksFields';
import SpeakerUploadsFields from '../shared/SpeakerUploadsFields';
import PostalAddressFields from '../shared/PostalAddressFields';

interface SpeakerSectionProps {
}

const SpeakerSection: FC<SpeakerSectionProps> = ({
}) => {
    return (
        <>
        <BasePersonSection
            title="Speaker Information"
            description="Please fill out the below information for travel and registration purposes."
            StyledAccordion={StyledAccordion}
            StyledAccordianSummary={StyledAccordianSummary}
            StyledAccordionDetails={StyledAccordionDetails}
            additionalFields={
                <>
                    <PostalAddressFields showPostalHeading={true} />
                    <SocialLinksFields />
                    <SpeakerUploadsFields />
                </>
            }
        />
        <ErrorFields
            errorFields={[
                "title",
                "firstName",
                "lastName",
                "email",
                "phoneNumber",
                "dietaryRequirements",
                "linkedInLink",
                "twitterLink",
                "jobDescription",
                "institution",
                "address",
                "suburb",
                "postcode",
                "country",
                "state",
                "postalStreet",
                "postalSuburb",
                "postalState",
                "postalCountry",
                "postalPostcode",
                "mobile",
                "speakerBio",
                "speakerPhoto",
                "speciality"
            ]}
        />
        </>

    )
}

export default SpeakerSection;
